export default {
  heading: 'Lato, san-serif',
  body: 'Lato, san-serif',
  monospace: 'Menlo, monospace',
  display: 'Playfair Display, serif',
  googleFonts: ['Lato:100,200,300,400,500,600,700,800,900', 'Playfair Display:400,500,600,700']
  // customFamilies: ['', ''],
  // customUrls: ['', ''],
}
